const OFP_SPEAKERS = [
  "Adam", 
  "Dan", 
  "George", 
  "Greg", 
  "John", 
  "Jonah", 
  "Marc", 
  "Patrick", 
  "Paul", 
  "Peter", 
  "Rich", 
  "Rob", 
  "Ted", 
  "Tom", 
  "Nikolai", 
  "Vitaliy", 
  "Sergey", 
  "Oleg", 
  "Ruslan", 
  "Aleksei", 
  "Andrei", 
  "Boris", 
  "Georgiy", 
  "Vadim", 
  "Vladimir", 
  "Ivan", 
];

export default OFP_SPEAKERS;